import process from "node:process";
import {
  resolveWakeLoopCliEntryNameFromArgv,
  WAKELOOP_HOME_ENV_KEY,
} from "../config/paths";

const PRODUCTION_WEB_RELEASE_ENTRY_NAME = "wakeloop";
const PRODUCTION_RELEASE_DEFAULT_ENV_KEYS = [
  WAKELOOP_HOME_ENV_KEY,
  "WAKELOOP_GATEWAY_URL",
  "WAKELOOP_AUTH_URL",
  "WAKELOOP_AUTH_CLIENT_ID",
  "WAKELOOP_ENV_PRESET",
  "WAKELOOP_DEV_MODE",
  "WAKELOOP_USER_FACING_CLI_COMMAND",
] as const;

type ProductionReleaseDefaultsInput = {
  argv?: string[];
  env?: NodeJS.ProcessEnv;
};

export function applyProductionReleaseDefaultsToProcessEnv(input?: {
  argv?: string[];
}): void {
  applyProductionReleaseDefaultsToEnvironment({
    argv: input?.argv,
    env: process.env,
  });
}

export function applyProductionReleaseDefaultsToEnvironment(
  input: ProductionReleaseDefaultsInput = {}
): void {
  if (!shouldUseProductionReleaseDefaults(input)) {
    return;
  }

  const env = input.env ?? process.env;
  for (const key of PRODUCTION_RELEASE_DEFAULT_ENV_KEYS) {
    Reflect.deleteProperty(env, key);
  }
}

export function shouldUseProductionReleaseDefaults(
  input: Pick<ProductionReleaseDefaultsInput, "argv"> = {}
): boolean {
  const argv = input.argv ?? process.argv;
  return (
    resolveWakeLoopCliEntryNameFromArgv(argv) ===
    PRODUCTION_WEB_RELEASE_ENTRY_NAME
  );
}
